import reactToText from "react-to-text";
import React from "react";

/**
 * Extracts plain text content from a React element by stripping all HTML/JSX markup.
 * Handles various React node types including primitives, components, and null/undefined values.
 *
 * @param element - The React element/node to extract text from
 * @returns Plain text string with whitespace normalized
 */
export function extractTextFromReactElement(element: React.ReactNode): string {
  try {
    if (element === null || element === undefined) {
      return "";
    }

    // Handle primitive types directly
    if (
      typeof element === "string" ||
      typeof element === "number" ||
      typeof element === "boolean"
    ) {
      return String(element);
    }

    // Extract text from React components using react-to-text
    const extractedText = reactToText(element);

    // Normalize whitespace and trim
    return extractedText.replace(/\s+/g, " ").trim();
  } catch (error) {
    console.warn("Failed to extract text from React element:", error);
    return "error";
  }
}
